import { render } from "./AddOrder.vue?vue&type=template&id=6d6f0b76&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"

import "./AddOrder.vue?vue&type=style&index=0&id=6d6f0b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6f0b76"]])

export default __exports__